
import { Card } from "@/components/ui/card";
import { Image } from "lucide-react";
import { BagData } from "@/types/bag";
import { Link } from "react-router-dom";

interface BagCardProps {
  bag: BagData;
  onClick?: () => void;
}

export function BagCard({ bag, onClick }: BagCardProps) {
  return (
    <Link to={`/bag/${bag.id}`} className="block h-full">
      <Card
        className="p-6 cursor-pointer hover:shadow-lg transition-shadow h-full"
        onClick={onClick}
      >
        <div className="flex flex-col space-y-4 text-left h-full">
          <p className="text-sm uppercase tracking-wider text-gold">
            Style {bag.style_number?.toString().padStart(4, "0")}
          </p>
          
          {bag.main_image ? (
            <div className="w-full aspect-square rounded-lg overflow-hidden border-2 border-gold/20 shadow-md">
              <img
                src={bag.main_image}
                alt={`${bag.Name} main view`}
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <div className="w-full aspect-square rounded-lg border-2 border-gold/20 flex items-center justify-center bg-cream">
              <Image className="w-1/4 h-1/4 text-gold/50" />
            </div>
          )}
          
          <div className="space-y-2 mt-auto">
            <p className="text-lg">{bag.Name}</p>
            <p className="text-sm text-muted-foreground">
              {bag.Category}
              {bag.Years_in_Production && ` • ${bag.Years_in_Production}`}
            </p>
          </div>
        </div>
      </Card>
    </Link>
  );
}
